export default {
  init() {
    // JavaScript to be fired on the home page
    $(document).ready(function() {
      // Initialize carousel
      $('#carouselHomeIndicators').carousel({
        interval: 5000,  // 5 seconds per slide
        ride: 'carousel',
        pause: 'hover',
      });

      // Initialize waypoints first
      if (typeof $.fn.waypoint !== 'undefined' && typeof $.fn.countUp !== 'undefined') {
        const $counters = $('.counter');
        if ($counters.length) {
          $counters.each(function() {
            const $counter = $(this);
            const value = $counter.text().trim();
            
            // Only proceed if the value is a valid number
            if (value && !isNaN(parseFloat(value))) {
              try {
                // Store the original value
                $counter.data('counterupTo', value);
                
                // Initialize with 0
                $counter.text('0');
                
                // Create the countUp instance with proper error handling
                $counter.waypoint(function() {
                  // Ensure the data array is properly initialized
                  if (!$counter.data('counterup-nums')) {
                    const targetValue = $counter.data('counterupTo');
                    const time = 2000;
                    const delay = 10;
                    const steps = time / delay;
                    
                    // Create the array of values for animation
                    const nums = [];
                    for (let i = steps; i >= 1; i--) {
                      const val = Math.round((targetValue / steps) * i);
                      nums.push(val);
                    }
                    
                    // Set the data array
                    $counter.data('counterup-nums', nums);
                    
                    // Start the animation
                    const animate = function() {
                      const currentNums = $counter.data('counterup-nums');
                      if (currentNums && currentNums.length) {
                        $counter.text(currentNums.shift());
                        setTimeout(animate, delay);
                      }
                    };
                    
                    setTimeout(animate, delay);
                  }
                }, {
                  offset: '100%',
                  triggerOnce: true,
                });
              } catch (error) {
                console.warn('CountUp initialization failed:', error);
                // Restore original value if initialization fails
                $counter.text(value);
              }
            }
          });
        }
      } else {
        console.warn('Required plugins not loaded. CountUp initialization skipped.');
      }
    });
  },
  
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
